export default __webpack_public_path__ + "static/media/aim.ee4f2d87.svg";